module.exports = __webpack_public_path__ + "static/img/img2.08acb99a.png";